import { useState, useEffect } from 'react';
import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';
import { api } from '@/lib/api.js';

export default function UsersPage() {
  const [roles, setRoles] = useState([]);
  const [rolesLoading, setRolesLoading] = useState(true);

  useEffect(() => {
    loadRoles();
  }, []);

  const loadRoles = async () => {
    try {
      const res = await api.get('/roles');
      setRoles(res.map(r => ({ value: r.code, label: r.name })));
    } catch (e) {
      console.error('Failed to load roles:', e);
      // Fallback to default roles
      setRoles([
        { value: 'admin', label: 'Admin' },
        { value: 'hr', label: 'HR' },
        { value: 'viewer', label: 'Viewer' },
      ]);
    } finally {
      setRolesLoading(false);
    }
  };

  if (rolesLoading) {
    return <div className="text-center py-8 text-slate-500">Loading roles...</div>;
  }

  return (
    <MasterCrudPage
      title="Users"
      description="System users (Admin / HR)"
      endpoint="/users"
      queryKey={['users']}
      fields={[
        { name: 'name', label: 'Name', required: true },
        { name: 'email', label: 'Email', type: 'email', required: true },
        { name: 'role', label: 'Role', type: 'select', required: true, default: 'hr', options: roles },
        { name: 'password', label: 'Password (leave blank to keep)', type: 'password' },
        { name: 'active', label: 'Status', type: 'select', default: 1, options: [
          { value: 1, label: 'Active' }, { value: 0, label: 'Inactive' },
        ]},
      ]}
      serialize={(v) => {
        const out = { name: v.name, email: v.email, role: v.role, active: Number(v.active) };
        if (v.password) out.password = v.password;
        return out;
      }}
      hydrate={(r) => ({ ...r, password: '' })}
      columns={[
        { key: 'name', header: 'Name', sortable: true },
        { key: 'email', header: 'Email', sortable: true },
        { key: 'role', header: 'Role', sortable: true },
        { key: 'active', header: 'Active', render: (r) => (r.active ? 'Yes' : 'No') },
      ]}
    />
  );
}
